import React, { useEffect, useState } from 'react';
import { Info, LockSimple, WarningCircle } from '@phosphor-icons/react';
import { IosSwitch } from '../../../../components/immobilien/ui';
import { darfAltarchivSteuern } from '../../../../lib/dokumente/altarchivUebernahme';
import { ladeSichtbarkeit, speichereSichtbarkeit, VERWALTUNG_ERKLAERUNG } from '../../../../lib/dokumente/verwaltungSichtbarkeit';

/** Erklärung des Verwaltungsobjekts im Aktenschrank, mit Sichtbarkeits-Schalter für Admins. */
export function VerwaltungHinweis() {
  const [alle, setAlle] = useState<boolean | null>(null);
  const [darf, setDarf] = useState(false);
  const [laeuft, setLaeuft] = useState(false);
  const [fehler, setFehler] = useState<string | null>(null);

  useEffect(() => {
    ladeSichtbarkeit().then(s => setAlle(s.alle)).catch(() => setAlle(false));
    darfAltarchivSteuern().then(setDarf).catch(() => setDarf(false));
  }, []);

  const umschalten = async (neu: boolean) => {
    setLaeuft(true); setFehler(null);
    try { await speichereSichtbarkeit(neu); setAlle(neu); }
    catch (e) { setFehler(e instanceof Error ? e.message : 'Speichern fehlgeschlagen'); }
    finally { setLaeuft(false); }
  };

  return (
    <section className="immo-innen flex flex-col min-w-0" style={{ borderRadius: 20, padding: '12px 14px', gap: 8 }} aria-label={VERWALTUNG_ERKLAERUNG.titel}>
      <div className="flex items-center" style={{ gap: 10 }}>
        <LockSimple weight="fill" size={18} color="var(--acc)" style={{ flexShrink: 0 }} />
        <span className="flex flex-col flex-1 min-w-0">
          <span style={{ fontSize: 14, fontWeight: 800 }}>{VERWALTUNG_ERKLAERUNG.titel}</span>
          <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--ink3)' }}>{alle === null ? '' : VERWALTUNG_ERKLAERUNG.sichtbar(alle)}</span>
        </span>
        {darf && (
          <span className="flex items-center shrink-0" style={{ gap: 8, fontSize: 12, fontWeight: 700, color: 'var(--ink2)' }}>
            <span className="hidden sm:inline">Für alle Mitarbeiter</span>
            <IosSwitch an={!!alle} onChange={an => { void umschalten(an); }} label="Für alle Mitarbeiter sichtbar" disabled={alle === null || laeuft} klein />
          </span>
        )}
      </div>
      <p style={{ margin: 0, fontSize: 12, lineHeight: 1.5, color: 'var(--ink2)' }}>{VERWALTUNG_ERKLAERUNG.was}</p>
      <p className="flex items-start" style={{ margin: 0, gap: 6, fontSize: 11, lineHeight: 1.5, color: 'var(--ink3)' }}>
        <Info size={13} style={{ flexShrink: 0, marginTop: 2 }} />{VERWALTUNG_ERKLAERUNG.nicht}
      </p>
      {fehler && <span className="flex items-center" style={{ gap: 6, fontSize: 12, color: 'var(--bad)' }}><WarningCircle weight="fill" size={14} />{fehler}</span>}
    </section>
  );
}
